// src/tenant.ts
const KEY = "njdc_tenant_id";

export function getStoredTenantId(): string {
  const v = (localStorage.getItem(KEY) || "").trim();
  return v || "demo";
}

export function setStoredTenantId(id: string) {
  localStorage.setItem(KEY, (id || "").trim());
}
